module.exports = __webpack_public_path__ + "img/4.a8434bd9.jpg";